<template>
    <div class="container">
        <div class="header">
            <div class="back" @click="back">
                <van-icon name="arrow-left" />
                <span>返回</span>
            </div>
        </div>
        <div class="title">解绑</div>
        <!-- 解除绑定 -->
        <div class="relieve_bind">
            <van-button type="danger" block size="small" @click="relieveBind">解除绑定</van-button>
            <span class="relieve_bind_tip">* 将该微信用户与医生解绑后，将会随机匹配医生进行问诊。</span>
        </div>
        <div class="title">更换医生</div>
        <div class="bind_content" v-watermark>
            <div class="bind_content_header">
                <div class="bind_content_header_item">医生</div>
                <div class="bind_content_header_item">状态</div>
                <div class="bind_content_header_item">已绑定用户数</div>
            </div>
            <div class="bind_content_list">
                <div class="bind_content_item" v-for="item in list" :key="item.doctorNo" @click="bindDoctor(item)">
                    <div class="bind_content_item_doctor">
                        <img :src="item.photo" alt="">
                        <span>{{item.name}}</span>
                    </div>
                    <div class="bind_content_item_status" :class="{'bind_content_item_status0': item.isOnline === 0}">{{item.doctorStatusName}}</div>
                    <div class="bind_content_item_num">
                        <span>{{item.boundUsersNum}}</span>
                        <van-icon name="arrow" />
                    </div>
                </div>
            </div>
        </div>
        <pagination :total="total" :pageSize="searchData.pageSize" @pageChange="pageChange"></pagination>
    </div>
</template>
<script>
import { Dialog } from 'vant';
import { getEnterpriseWechatlist, userUnbindingDoctor, userBindingDoctor } from '../../api/home.js'
export default {
    data() {
        return {
            total: 0,
            searchData: {
                pageSize: 10,
                pageNum: 1,
                doctorStatus: 0
            },
            list: [],
            item: {},
            userNos: [],
        }
    },
    created() {
        this.getList()
        this.userNos = JSON.parse(sessionStorage.getItem('userNos'))
    },
    methods: {
        getList() {
            getEnterpriseWechatlist(this.searchData).then(res => {
                if(res.code == 0){
                    this.list = res.data.list || [];
                    this.total = res.data.total
                }
            })
        },
        pageChange(pageNo) {
            this.searchData.pageNum = pageNo
            this.getList()
        },
        relieveBind() {
            let content = `确定将${this.userNos.length}位用户所绑定的医生统一解绑，<span style="color: #ee0a24">如有进行中的问诊，将会一同转移给换绑后的医生。</span>`
            if(this.$route.query.doctorNoName){
                content = `确定将该用户与${this.$route.query.doctorNoName}医生解绑？<span style="color: #ee0a24">如有进行中的问诊，将会一同转移给换绑后的医生。</span>`
            }
            Dialog.confirm({
                title: '提示',
                message: content,
                allowHtml: true
            })
            .then(() => {
                // on confirm
                this.userUnbindingDoctor()
            })
            .catch(() => {
                // on cancel
            });
        },
        userUnbindingDoctor() {
            let data = {
                userNos: this.userNos
            }
            userUnbindingDoctor(data).then(res => {
                this.$toast.success('解绑医生成功')
                    setTimeout(() => {
                        this.$router.back()
                    }, 1500);
            })
        },
        bindDoctor(row) {
            let content = `确定将${this.userNos.length}位用户所绑定的医生统一更换为${row.name}？<span style="color: #ee0a24">如果确认换绑，则把该进行中的问诊也转移给新医生。</span>`
            if(this.$route.query.doctorNoName){
                content = `确定将该用户所绑定的医生由${this.$route.query.doctorNoName}更换为${row.name}？<span style="color: #ee0a24">如果确认换绑，则把该进行中的问诊也转移给新医生。</span>`
            }
            Dialog.confirm({
                title: '提示',
                message: content,
                allowHtml: true
            })
            .then(() => {
                // on confirm
                let data = {
                    userNos: this.userNos,
                    doctorNo: row.doctorNo
                }
                this.userBindingDoctor(data)
            })
            .catch(() => {
                // on cancel
            });
        },
        userBindingDoctor(data) {
            userBindingDoctor(data).then(res => {
                if(res.code == 0){
                    this.$toast.success('绑定医生成功')
                    setTimeout(() => {
                        this.$router.back()
                    }, 1500);
                }
            })
        },
        // 返回
        back() {
            this.$router.back()
        }
    }
}
</script>
<style lang="scss" scoped>
    .container {
        padding: 10px;
        .header {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            font-weight: bold;
            color: #333333;
            position: relative;
            font-size: 16px;
            margin: -10px -10px 0 -10px;
            .back {
                display: flex;
                align-items: center;
                position: absolute;
                left: 10px;
                font-weight: 500;
                color: #666666;
                font-size: 14px;
                cursor: pointer;
            }
        }
        .title {
            padding: 13px 10px;
            font-weight: bold;
            color: #333333;
            font-size: 16px;
        }
        .relieve_bind {
            // width: 100%;
            height: 117px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            margin: 0px -10px 0 -10px;
            padding: 0 25px 0 26px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            color: #E81C1C;
            font-size: 14px;
            .relieve_bind_tip {
                margin-top: 13px;
            }
        }
        .bind_content {
            width: 100%;
            background: #FFFFFF;
            border-radius: 4px;
            padding: 16px;
            box-sizing: border-box;
            height: calc(100vh - #{'360px'});
            overflow-y: scroll;
            .bind_content_header {
                width: 100%;
                height: 44px;
                background: #F6FBFF;
                display: flex;
                align-items: center;
                padding: 0 12px;
                box-sizing: border-box;
                .bind_content_header_item {
                    width: 33.33%;
                    color: #333333;
                    font-size: 14px;
                }
            }
            .bind_content_list {
                font-size: 14px;
                color: #333333;
                .bind_content_item {
                    width: 100%;
                    height: 44px;
                    display: flex;
                    align-items: center;
                    background: transparent;
                    padding: 0 12px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #F6FBFF;
                    cursor: pointer;
                    & > div {
                        width: 33.33%;
                    }
                    .bind_content_item_doctor {
                        display: flex;
                        align-items: center;
                        img {
                            width: 28px;
                            height: 28px;
                            border-radius: 50%;
                            margin-right: 8px;
                        }
                    }
                    .bind_content_item_status {
                        color: #0FBC54;
                    }
                    .bind_content_item_status0 {
                        color: #999999;
                    }
                    .bind_content_item_num {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                }
            }
        }
    }
</style>